<!-- 答题卡 -->
<template>
    <div class="answerSheet">
        <van-sticky>
            <div class="answerSheetTitle commonStatus">
                <div class="answerTitle">
                    <slot name="title">答题卡</slot>
                </div>
                <div class="answerStatus">
                    <template v-if="modeType == 2">
                        <div class="answerStatus-item">
                            <div class="answerStatus-item-dot success"></div>
                            <div class="answerStatus-item-title">正确</div>
                        </div>
                        <div class="answerStatus-item">
                            <div class="answerStatus-item-dot fail"></div>
                            <div class="answerStatus-item-title">错误</div>
                        </div>
                        <div v-if="isShowAnswered" class="answerStatus-item">
                            <div class="answerStatus-item-dot answered"></div>
                            <div class="answerStatus-item-title">已答</div>
                        </div>
                    </template>
                    <template v-if="modeType == 1">
                        <div class="answerStatus-item">
                            <div class="answerStatus-item-dot answered"></div>
                            <div class="answerStatus-item-title">已答</div>
                        </div>
                    </template>
                    <div v-if="isShowCurrent" class="answerStatus-item">
                        <div class="answerStatus-item-dot currentAnswer"></div>
                        <div class="answerStatus-item-title">当前</div>
                    </div>
                    <div v-if="isShowCurrent" class="answerStatus-item">
                        <div class="answerStatus-item-dot unanswered"></div>
                        <div class="answerStatus-item-title">未答</div>
                    </div>
                    <!-- <div class="answerStatus-item">
                        <div class="answerStatus-item-dot">
                            <img src="@/assets/images/homeWork/shortQuestion.png" alt="">
                        </div>
                        <div class="answerStatus-item-title">简答题</div>
                    </div> -->
                </div>
            </div>
        </van-sticky>
        <div class="answerSheetContent commonStatus">
            <div class="answerSheetContent-item"
                v-for="(item, index) in questionList"
                :key="item.id"
                :class="questionClass(item, index)"
                @click="handleClick(item, index)"
                >
                <div class="answerSheetContent-item-dot">
                    <span>{{index + 1}}</span>
                    <template v-if="item.type == 4">
                        <img src="@/assets/images/homeWork/shortQuestionBottom.png" alt="">
                    </template>
                </div>
            </div>
        </div>
        <div v-if="isShowSubmit" class="btnBox">
            <div class="btn" @click="btnSubmitClick">提交作业</div>
        </div>
    </div>
 </template>

 <script>
 import Vue from 'vue';
 import { Sticky } from 'vant';
 Vue.use(Sticky);
 export default {
    props: {
        questionList: {
            type: Array,
            default: () => []
        },
        curQuestionNum: {
            type: Number,
            default: 0
        },
        modeType: { // 1为考试模式 2为逐题模式
            type: [String, Number],
            default: ''
        },
        isShowSubmit: { // 是否显示提交按钮
            type: Boolean,
            default: true
        },
        isShowCurrent: { // 是否显示当前题目
            type: Boolean,
            default: true
        },
        isShowAnswered: { // 是否显示已答 主要用于逐题模式中做题时未点确认直接切换题目后展示状态
            type: Boolean,
            default: false
        }
    },
    data () {
        return {}
    },
    computed: {
        questionClass() {
            return (item, index) => {
                let classArr = []
                // item.user_answer ? (modeType == 1 ? 'answered' : this.grtSortData(item.user_answer) == this.grtSortData(item.answer) ? 'success' : 'fail') : 'unanswered',
                // item.type === 4 ? 'shortQuestion' : '',
                // (curQuestionNum == index) && isShowCurrent ? 'currentAnswer' : '',

                // 判断用户答案的状态
                if (item.user_answer) {
                    if (this.modeType === 1) {
                        classArr.push('answered')
                    } else {
                        if (item.isShowAnswered) {
                            classArr.push('answered')
                        } else {
                            const isSuccess = this.grtSortData(item.user_answer) === this.grtSortData(item.answer)
                            classArr.push(isSuccess ? 'success' : 'fail')
                        }
                    }
                } else {
                    classArr.push('unanswered')
                }
                // 判断题目类型
                if (item.type === 4) {
                    classArr.push('shortQuestion')
                }

                // 判断是不是当前显示状态
                if (this.curQuestionNum === index && this.isShowCurrent) {
                    classArr.push('currentAnswer')
                }

                return classArr

            }
        }

    },
    methods: {
        grtSortData(data) {
            if (data) {
                return data.split('').sort().join('')
            }
            return 0
        },
        btnSubmitClick() {
            this.$emit('btnSubmitClick')
        },
        handleClick(item, index) {
            this.$emit('handleClick', item, index)
        }
    }
 }
 </script>

 <style lang="scss" scoped>
 .answerSheet {
    box-sizing: border-box;
    .answerSheetTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: #666666;
        .answerTitle {
            font-size: 16px;
            font-weight: bold;
            color: #202020;
        }
        .answerStatus {
            display: flex;
            align-items: center;
            .answerStatus-item {
                margin-left: 9px;
                display: flex;
                align-items: center;
                .answerStatus-item-dot {
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    margin-right: 4px;
                    border: 1px solid #E3E8E9;
                    box-sizing: border-box;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                
            }
        }
    }
    .answerSheetContent {
        display: flex;
        margin-top: 12px;
        flex-wrap: wrap;
        gap: 12px;
        font-size: 14px;
        padding-bottom: 12px;
        overflow-y: scroll;
        // min-height: 140px;
        max-height: 420px;
        overflow-y: auto;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            display: none; /* Safari 和 Chrome */
        }
        .answerSheetContent-item {
            display: flex;
            align-items: center;
            width: 34px;
            height: 34px;
            border: 1px solid #E3E8E9;
            color: #202020;
            background-color: #ffffff;
            justify-content: center;
            position: relative;
            border-radius: 50%;
            box-sizing: border-box;
            overflow: hidden;
            .answerSheetContent-item-dot {
                img {
                    position: absolute;
                    bottom: 0px;
                    left: 0;
                    width: 100%;
                    height: 10px;
                    border-radius: 0 0 50% 50%;
                }
            }
        }
    }
    .btnBox {
        width: 100%;
        padding: 8px 0;
        box-sizing: border-box;
        .btn {
            height: 36px;
            line-height: 36px;
            text-align: center;
            background-color: #286BFF;
            font-size: 15px;
            color: #ffffff;
            border-radius: 100px;
        }
    }
 }

 .commonStatus {

    
    .success {
        background: #10B881 !important;
        border: 1px solid #10B881 !important;
        color: #ffffff !important;
    }
    .fail {
        background: #FF8982 !important;
        border: 1px solid #FF8982 !important;
        color: #ffffff !important;
    }
    .shortQuestion {
        background: #E3E8E9 !important;
        border: 1px solid #E3E8E9 !important;
        color: #202020 !important;
    }
    .answered {
        background: #286BFF !important;
        border: 1px solid #286BFF !important;
        color: #ffffff !important;
    }
    .currentAnswer {
        background: #D4E1FF !important;
        border: 1px solid #D4E1FF !important;
        color: #286BFF !important;
    }
 }
 </style>